<template>
    <div class="d-flex flex-column flex-root">
        <div
                class="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid bg-white"
                id="kt_login"
        >
            <!--begin::Aside-->
            <div
                    class="hide-sm hide-md custom_login_aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-7"
            >
                <!--begin: Aside Container -->
                <div class="d-flex flex-row-fluid flex-column justify-content-between">
                    <!--begin: Aside header -->
                    <a class="flex-column-auto" href="#">
                        <img class="h-20" src="media/logos/externalis_logo.png"/>
                    </a>
                    <!--end: Aside header -->
                    <!--begin: Aside content -->
                    <div
                            class="auth_media_inner flex-column-fluid d-flex flex-column justify-content-center"
                    >
                        <img class="auth_image" src="media/misc/auth-image.png"/>
                        <h3 class="auth_header mt-10 mb-5">
                            Screenshot any web page and proof it
                        </h3>
                        <p class="auth_sub_heading opacity-80">
                            Create a proof of any website content and get them stored in the
                            blockchain.
                        </p>
                    </div>
                    <!--end: Aside content -->
                </div>
                <!--end: Aside Container -->
            </div>
            <!--begin::Aside-->

            <!--begin::Content-->
            <div
                    class="auth_content_bg flex-row-fluid d-flex flex-column position-relative p-7 overflow-hidden"
            >
                <div class="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
                    <router-view></router-view>
                </div>
            </div>
            <!--end::Content-->
        </div>
    </div>
</template>


<script>
   export default {
      name: "auth",
      methods: {},
   };
</script>


<!-- Load login custom page styles -->
<style>
    /*Media Query For All Mobile Screens*/
    @media (min-width: 300px) and (max-width: 767px) {
        .hide-sm {
            visibility: hidden;
            float: none !important;
            display: none !important;
        }
    }

    /*Media Query For All Tablets Screens*/
    @media (min-width: 768px) and (max-width: 991px) {
        .hide-md {
            visibility: hidden;
            float: none !important;
            display: none !important;
        }
    }

    /*Media Query For mini Laptops and Desktops Screens*/
    @media (min-width: 992px) and (max-width: 1157px) {
        .hide-lg {
            visibility: hidden;
            float: none !important;
            display: none;
        }
    }

    /*Media Query For Laptops and Desktops Screens*/
    @media (min-width: 1158px) and (max-width: 1280px) {
        .hide-lg {
            visibility: hidden;
            float: none !important;
            display: none;
        }
    }

    /*Media Query For Desktops Screens*/
    @media only screen and (max-width: 6000px) and (min-width: 1200px) {
        .hide-lg {
            visibility: hidden;
            float: none !important;
            display: none;
        }
    }
</style>

<style lang="scss">
    @import "@/assets/sass/pages/login/login-1.scss";
</style>
